// @flow
import React, { Component } from "react";
import classNames from "classnames";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";

const styles = (theme: DictionaryType): DictionaryType => ({
  menuItem: {
    "& $text, & $icon": {
      color: theme.palette.primary.contrastText
    }
  },
  menuItemSelected: {
    background: theme.palette.primary.main + " !IMPORTANT",
    "& $text, & $icon": {
      color: theme.palette.primary.contrastText
    }
  },
  text: {},
  icon: {},
  nested: {
    paddingLeft: theme.spacing.unit * 4
  }
});

type NavbarMenuItemClassesType = {
  menuItem: DictionaryType,
  menuItemSelected: DictionaryType,
  text: DictionaryType,
  icon: DictionaryType,
  nested: DictionaryType
};

type NavbarMenuItemPropType = {
  classes: NavbarMenuItemClassesType,
  text: string,
  icon?: React$Element<*>,
  onClick?: Function,
  selected?: boolean,
  isSubHeader?: boolean,
  open?: boolean,
  isNested?: boolean
};

class NavbarMenuItem extends Component<*, NavbarMenuItemPropType> {
  render(): React$Element<*> {
    const classes = this.props.classes;

    return (
      <MenuItem
        classes={{
          root: classNames(
            classes.menuItem,
            this.props.isNested && classes.nested
          ),
          selected: classes.menuItemSelected
        }}
        selected={this.props.selected}
        {...(this.props.onClick ? { onClick: this.props.onClick } : {})}
      >
        {this.props.icon && (
          <ListItemIcon className={classes.icon}>
            {this.props.icon}
          </ListItemIcon>
        )}
        <ListItemText
          classes={{ primary: classes.text }}
          inset
          primary={this.props.text}
        />
        {this.props.isSubHeader &&
          (this.props.open ? (
            <ExpandLess className={classes.icon} />
          ) : (
            <ExpandMore className={classes.icon} />
          ))}
      </MenuItem>
    );
  }
}

export default withStyles(styles)(NavbarMenuItem);
